// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import '@atlassian/jira-portfolio-3-common/src/css-variables/variables.css';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import 'react-virtualized/styles.css';
import React, { useEffect } from 'react';
import { initBrowserMetrics3 } from '@atlassian/jira-browser-metrics';
import type { Locale } from '@atlassian/jira-common-constants/src/supported-locales';
import { resetReduxStore } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command';
import store from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/store';
import type { ApplicationEdition } from '@atlassian/jira-shared-types';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import './styles.css';
import App from './view';

type Props = {
	locale: Locale;
	edition: ApplicationEdition;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => {
	const { locale, edition } = props;

	useEffect(() => {
		if (
			window.location.pathname.includes('PortfolioEmbeddedReportView.jspa') ||
			window.location.pathname.includes('PlanEmbeddedReportView.jspa')
		) {
			/**
			 * Initializing the BM3 performance instrumentation for legacy page. It starts the
			 * page load and also adds some performance related metadata. The metric is stopped in
			 * src/packages/portfolio-3/portfolio/src/common/analytics/performance.js#L122
			 */
			initBrowserMetrics3();
		}

		/**
		 * Resetting the redux store while unmounting the application. Please refer to the
		 * detailed explanation provided at
		 * src/packages/portfolio-3/portfolio/src/app-simple-plans/command/index.js#L535
		 */
		return function arjAppUnmounted() {
			store.dispatch(resetReduxStore());
		};
	}, []);

	return <App locale={locale} edition={edition} store={store} />;
};
